import { assignment } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function setAssignmentProcessed({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function setAssignmentProcessed(
    loanApplicationID: string
  ): Promise<assignment.Assignment> {
    const url = new URL(
      `/assignment/application/${loanApplicationID}/processed`,
      baseURL
    );
    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to set assignment processed');
    }
  };
}
